import { ErrorHandler, Injectable } from '@angular/core';
import { RumService, toError } from '@spotlight/shared/rum';
import { AnalyticsService } from '../analytics';

/**
 * Angular `ErrorHandler`: hands uncaught errors to the browser so Datadog RUM collects them natively
 * as unhandled errors, and sends the `Console Error Thrown` Amplitude event. Angular catches these
 * errors itself, so RUM's own error hooks never see them. Failed requests that were already
 * handled (RUM records them as resources) are logged only.
 */
@Injectable()
export class ConsoleErrorHandlerService implements ErrorHandler {
  constructor(
    private readonly analytics: AnalyticsService,
    private readonly rum: RumService
  ) { }

  public handleError(error: unknown): void {
    const errorObj = toError(error);
    if (this.rum.isAlreadyReported(error)) {
      console.error(errorObj);
    } else {
      this.rum.reportUncaughtError(errorObj);
    }
    this.analytics.sendEvent(
      'Console Error Thrown',
      {
        error: errorObj.message || 'Undefined Error',
        stackTrace: errorObj.stack || 'Undefined Stack'
      }
    );
  }
}
